<template>
  <CContainer>
    <CRow>
      <transition appear name="slide" type="animation">
        <CCard :class="{'card-complete': complete}">
          <CCardHeader class="pb-0">
            <!-- display meatball icon -->
            <CRow>
              <CCol>
                <div
                  v-if="this.$store.getters['auth/userStatus']"
                  @click="showMenu"
                  class="straigtMenu"
                >
                  <i class="fa fa-ellipsis-h fa-2x" color="#B3B3B3" />
                </div>
              </CCol>
            </CRow>

            <!-- display title -->
            <CRow>
              <CCol
                class="font-weight-bold card-title"
                @click="sendCourseData(data)"
              >{{data.title[0].val}}</CCol>
            </CRow>
          </CCardHeader>
          <CCardBody @click="sendCourseData(data)">
            <!-- for click area -->
            <div>
              <!-- display fullname -->
              <CRow>
                <CCol>
                  <p
                    style="font-size: 1.5rem; margin-bottom: 0.5rem; font-weight: bold; overflow: hidden;text-overflow: ellipsis;color:white"
                  >{{ data.name[0].val }}</p>
                </CCol>
              </CRow>

              <!-- display  study hrs-->
              <CRow>
                <CCol class="description">Study hours</CCol>
                <CCol class="text-right description">{{data.studyHour}}</CCol>
              </CRow>

              <!-- display Category -->
              <CRow>
                <CCol class="description">Category</CCol>
                <div v-if="data.categorys.length == 4">
                  <CCol class="text-right description">
                    {{data.categorys[0].category.title[0].val}}
                    <br />
                    <p></p>
                  </CCol>
                </div>
                <div v-else-if="data.categorys.length == 2">
                  <CCol class="text-right description">
                    {{data.categorys[0].category.title[0].val}}
                    <br />
                    <div style="margin-top: -0.2rem">{{data.categorys[1].category.title[0].val}}</div>
                  </CCol>
                </div>
              </CRow>

              <!-- display views -->
              <CRow>
                <CCol class="description">views</CCol>
                <CCol class="text-right description">
                  <div v-if="data.views">{{data.views.length}}</div>
                  <div v-else>0</div>
                </CCol>
              </CRow>
            </div>

            <!-- display progress bar and button -->
            <CRow class="mt-3">
              <CCol class="position-relative">
                <CProgress
                  showPercentage
                  :value="value"
                  :max="max"
                  class="progressBar"
                  show-value
                  border-radius="50px"
                >
                  <CProgressBar style="border-radius:20px; background-color: #2a4388"></CProgressBar>
                </CProgress>
              </CCol>
              <CCol class="text-right overviewIcon">
                <router-link to="/Exprofile">
                  <img
                    src="@/assets/icons/homepage/GotoOverview.svg"
                    alt="overview"
                    width="43"
                    height="43"
                  />
                </router-link>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </transition>

      <!-- display menu -->
      <transition name="slide" type="animation">
        <div v-show="showingMenu" class="ml-3">
          <div v-for="(item, index) in menu" :key="index">
            <span
              v-c-tooltip.click.hover="{
                    content: item.name,
                    placement: 'right',
                    }"
              @click="clickIcon(item.name)"
              class="fav-star"
            >
              <i
                :class="item.icon"
                :color="item.color"
                style="height: 16px; width: 16px; margin-top: 0.95rem;"
              />
            </span>
          </div>
        </div>
      </transition>
    </CRow>
    <!-- ------------------------------------------------------------Cmodal-------------------------------------------------------------- -->
  </CContainer>
</template>
<script>

export default {
  data() {
    return {
      isVisible: false,
      showingMenu: false,
      value: 0,
      max: 100,
      menu: [
        // {
        //   name: "unenrolled",
        //   status: false,
        //   color: "#FF5050",
        //   icon: "fas fa-ban"
        // },
        {
          name: "star",
          status: false,
          color: "gray",
          active: require("@/assets/icons/cardMenu/favorite.svg"),
          nonActive: require("@/assets/icons/cardMenu/non-favorite.svg"),
          icon: "fas fa-star",
        },
        /*
        {
          name: "overview",
          status: false,
          color: " #6868FF",
          icon: "fas fa-eye"
        },
        {
          name: "progress",
          status: false,
          color: "#58C958",
          icon: "fas fa-flag"
        },
        {
          name: "share",
          status: false,
          color: "#6767FF",
          icon: "fas fa-share-square"
        }*/
      ],
    };
  },
  props: {
    data: Object,
    complete: Boolean,
  },
  mounted() {
    
  },
  methods: {
    showMenu() {
      this.showingMenu = !this.showingMenu;
    },
    clickIcon(icon) {
      // alert("icon: " + icon);
      //   this.onPressUnenrollModal();
      // if (icon == "unenrolled") {
      //   this.onPressUnenrollModal();
      // }

      /*
      if (icon == "progress") {
        this.$router.push("/InprogressCourseDetail");
      }
      if (icon == "overview") {
        this.$router.push("/Overview");
      }*/
      let user_id = this.$store.getters["auth/userInformation"]._id;
      switch (icon) {
        case "star":
          let body = {
            course_id: this.data,
            user_id: user_id,
          };
          this.showMenu();
          this.$store.dispatch("addFavoutiteCourse", body);
          return;
        default:
          return;
      }
    },
    sendCourseData(data) {
      let courseCodeData = {
        courseCode: data.code,
        objectId: data._id,
      };
      this.$store.commit("dataCourse", courseCodeData);
      this.$router.push({
        name: "Overview",
        params: {
          courseCode: data.code,
          courseID: data._id,
        },
      });
    },
    onPressUnenrollModal() {
      this.isVisible = true;
    },
  },
};
</script>

<style scoped>
.card-complete {
  background-image: url("../../assets/icons/completed_logo.svg");
  background-repeat: no-repeat;
  background-size: 120px;
  background-position: 125px 200px;
}
.card {
  transition: transform 0.2s;
  position: relative;
  width: 260px;
  height: 290px;
  border-radius: 40px;
  background-color: #2a4388;
  margin-top: 0rem;

  box-shadow: 5px 5px 10px #0000004d;
  border-radius: 40px;
  background-blend-mode: soft-light;
  color: white;
}
.card-header {
  background-color: transparent;
  border: none;
  padding-top: 0px;
}

.card-body {
  padding: 0rem 1.25rem;
}

.card:hover {
  cursor: pointer;
  transition-delay: 0.3s;
}
.fav-star {
  border-radius: 50%;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  background: #fff;
  box-shadow: 1px 1px 2px black;
  cursor: pointer;
}
.straigtMenu {
  z-index: 999;
  margin-right: -0.3rem;
  position: absolute;
  background: white;
  height: 40px;
  width: 57px;
  text-align: end;
  right: 0;
  /* become => flex box easy to align */
  display: flex;
  /* vertically for child */
  justify-content: center;
  /* Horizontally for child  */
  align-items: center;
  border-radius: 0px 40px;
}

.straigtMenu:hover {
  /* -webkit-filter: brightness(70%); */
  filter: brightness(70%);
}

.progressBar {
  width: 9rem;
  height: 43px;
  border-radius: 50px;
  box-shadow: none;
  padding: 5px;
  overflow: visible;
}

.overviewIcon:hover {
  /* -webkit-filter: brightness(70%); */
  filter: brightness(0.4);
}

.description {
  font-size: 0.875rem;
}

/* -- ---------------------------------------------------------- CSS MODAL -------------------------------------------------- -- */

.closeButton {
  align-content: flex-end;
  float: right;
  width: 26px;
  height: 26px;
  padding-top: -100px;
  margin-right: 12px;
  cursor: pointer;
  margin-bottom: 0.1em;
}

.button {
  outline: none;
  border: none;
  width: 12rem;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 40px;
  font-size: 16px;
  margin: 10px;
}

.drobdown_modal {
  width: 90%;
  border: 0px;
  border-bottom: 1px solid #cccccc;
  margin-left: 20px;
}

.modal-text p {
  font-weight: 300;
  font-size: 16px;
  color: black;
  margin-bottom: 0px;
}

.modal-text h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: black;
  text-align: center;
}

.modal-content p {
  font-size: 24px;
  margin-top: 0.6em;
}

.tab {
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

.widthLoginModal {
  width: 420px;
  position: inherit;
}

.slide-enter {
  opacity: 0;
}

.slide-enter-active {
  transition: opacity 0.4s;
  animation: slide-in 0.4s ease-out forwards;
}

/* .slide-leave {
} */

.slide-leave-active {
  transition: opacity 0.4s;
  opacity: 0;
  animation: slide-out 0.4s ease-in forwards;
}

@keyframes slide-in {
  from {
    transform: translateX(-1.5rem);
  }
  to {
    transform: translateX(0rem);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0rem);
  }
  to {
    transform: translateX(-1.5rem);
  }
}
</style>
